// Edit this file to personalize the site. Null links are intentional, visible placeholders.
export const portfolio = {
  name: "Darren",
  legalName: "Darren Hayden",
  role: "Creative Front-End Developer",
  location: "Colorado, USA",
  availability:
    "Open to junior developer roles, agency work, and freelance projects.",
  available: true,
  email: "contact@darrenhportfolio.com" as string | null,
  linkedin: "https://www.linkedin.com/in/darren-hayden-developer",
  github: "https://github.com/thegoldengamer55",
  resume: null as string | null, // TODO: put resume.pdf in public and set '/resume.pdf'.
  experience: [] as { role: string; organization: string; dates: string }[],
  education: [] as {
    qualification: string;
    institution: string;
    dates: string;
  }[],
  technologies: [
    "React",
    "TypeScript",
    "Three.js",
    "JavaScript",
    "HTML & CSS",
    "React Router",
    "SCSS",
    "Git",
  ],
  about: [
    "I’m Darren, a front-end developer based in Colorado. I build websites with React, TypeScript, and have a growing interest in 3D. I like figuring out how a page should look, then getting into the code to make it work.",
    "Collegiate distance running taught me to be patient with progress. That carries over into my work: try something, see where it falls short, and come back to it with a better idea.",
    "Music is a big part of my life, too. I think about timing when I’m building an interaction: how quickly a menu opens, when an animation settles, or when a page needs to stay still.",
  ],
};

export const navigation = [
  { label: "Work", to: "/#work", section: "work" },
  { label: "Expertise", to: "/#expertise", section: "expertise" },
  { label: "About", to: "/about", section: "about" },
  // Restore when the build notes are ready to share.
  // { label: "Behind the build", to: "/behind-the-build", section: "behind-the-build" },
];

export const expertise = [
  {
    title: "Creative development",
    text: "I build responsive pages and add motion where it helps: a smoother transition, a clearer state change, or a detail worth exploring.",
    tags: "Interaction / Motion / Responsive web",
  },
  {
    title: "3D web experiences",
    text: "I bring Blender models into the browser with Three.js, with controls to explore them and still images for when 3D isn’t the right fit.",
    tags: "Three.js / WebGL / Product storytelling",
  },
  {
    title: "Front-end development",
    text: "I use React and TypeScript to build reusable components, handle the awkward edge cases, and make navigation work with a keyboard.",
    tags: "React / TypeScript / Accessibility",
  },
  {
    title: "Digital product design",
    text: "I work through page layouts, type, and color so people can find what they need and know what to do next.",
    tags: "Visual systems / UI / Prototyping",
  },
];

export const process = [
  {
    title: "Discover",
    text: "First, I ask who the site is for, what they need, and what the project needs to accomplish.",
  },
  {
    title: "Design",
    text: "I sketch the page structure, work out the visual direction, and try the main interactions before building everything.",
  },
  {
    title: "Develop",
    text: "I build the main flow first, then work through smaller screens, keyboard controls, and loading or error states.",
  },
  {
    title: "Refine",
    text: "I test what I’ve built, ask for feedback, and revisit the parts that feel slow, confusing, or unfinished.",
  },
];
